import './css/App.css';
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LayoutApp } from './layout/Layout';
import { SSO } from './pages/sso';
import { NotFound } from './pages/notfound';
import { Unauthorized } from './pages/Unauthorized';


function App() {
  // const [loading, setLoading] = useState(true);
  // const [bg, setBg ] = useState(``);
  // const [typeBg, setTypeBg] = useState(``);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NotFound />} />
          <Route path="/:appId" element={ <SSO />}></Route>
          <Route path="/unauthorized/:appId" element={<Unauthorized />} />
          <Route path="/404/:APP_ID" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
